import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let FightingMasteries = class FightingMasteries extends VuexModule {
    constructor() {
        super(...arguments);
        this.fightingMasteries = [];
        this.cachedVersion = 0;
    }
    async fetchFightingMasteries() {
        const { data: fightingMasteries, cachedVersion } = await fetchFromCache(this, 'fightingMasteries', 'fightingMastery');
        return { fightingMasteries, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['fightingMasteries', 'cachedVersion'] })
], FightingMasteries.prototype, "fetchFightingMasteries", null);
FightingMasteries = __decorate([
    Module({ namespaced: true, name: 'fightingMasteries' })
], FightingMasteries);
export default FightingMasteries;
